export default {
      id: "arrow-down-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-down-right",
      toString: function () {
        return this.url;
      }
    }